<template>
  <div class="goodsManageAddPage">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.id"
        >
        <van-image width="100%" fit="scale-down" :src="item" />
      </van-swipe-item>
    </van-swipe>

    <div class="main_content">
      <div class="good_description">
        <div class="item">
          <p>商品ID：{{ detail.id }}</p>
          <p>商品名称：{{ detail.commodityname }}</p>
        </div>
        <div class="item">
          <div class="block">
            <!-- <p>排序：{{ detail.sort }}</p> -->
            <p>企业名称（ID）：{{ detail.qyname ? detail.qyname : detail.qy_accountid }}</p>
            <p>是否上架：{{ detail.commoditystate }}</p>
            <p>销售状态：{{ detail.salestate }}</p>
          </div>
          <div class="block">
            <p>是否精品推荐：{{ detail.isintro }}</p>
            <p>是否置顶：{{ detail.istop == 1 ? "是" : "否" }}</p>
            <p>限购状态：<span v-if="detail.islimit">{{ detail.islimit == '不限购' ? detail.islimit : '每人限购/'+detail.limitnum+'件' }}</span></p>
            <p>SKU采购编码：{{ detail.sku }}</p>
            <p>品牌标签：{{ this.brand_name(detail.brandid) }}</p>
          </div>
        </div>
        <div class="item">
          <div class="block">
            <p>ISBN编码：{{ detail.ISBN }}</p>
          </div>
          <div class="block">
            <p>
              所属分类：{{
                this.label_name(
                  detail.labelid,
                  detail.labelid2,
                  detail.labelid3
                )
              }}
            </p>
            <p>商品类型：{{ detail.comtype }}</p>
            <p>结算类型：{{ detail.paytype }}</p>

            <p>基础零售价：{{ detail.price }}</p>
            <p>普通用户积分兑换值：{{ detail.userscore1 }}</p>
            <p>商务合作用户积分兑换值：{{ detail.userscore2 }}</p>
          </div>
          <div class="block">
            <p>企业积分兑换值：{{ detail.userscore3 }}</p>
            <!-- <p class="flex-between">
              <span>批发商品组规格：{{ detail.groupnum }}</span
              ><span>件/每组</span>
            </p> -->
            <p>基础批发价：{{ detail.pfprice }}</p>
            <p class="">
            <!-- <p class="flex-between"> -->
              <span>单款混选起批数量：{{ detail.startnum2 }}</span
              ><span>件/起批</span>
            </p>
            <!-- <p class="flex-between">
              <span>混样多选起批数量：{{ detail.startnum2 }}</span
              ><span>组</span>
            </p> -->
          </div>
        </div>
      </div>

      <div class="good_operation flex-between">
        <router-link
          :to="'/commondityIndex/cManageEdit/cBaseinfo/' + id"
          class="item"
          >基础信息设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cImages/' + id"
          class="item"
          >产品图片设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cSalesParams/' + id"
          class="item"
          >销售参数设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cAttrLabel/' + id"
          class="item"
          >属性标签&规格变量设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cLabel/' + id"
          class="item"
          >商品标签设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cDetail/' + id"
          class="item"
          >商品详情设置</router-link
        >
        <router-link
          :to="'/commondityIndex/cManageEdit/cOthers/' + id"
          class="item"
          >其他设置</router-link
        >
      </div>
    </div>

    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  getBrandList,
  getCommondityLabel,
} from "../../api/api";
export default {
  name: "cManageDetail",
  data() {
    return {
      id: "",
      tabbarActive: 0,
      bannerList: "", // 商品banner
      brandList: "", // 品牌列表
      shopLabelFirst: "", // 商品所属分类
      detail: "", // 详情列表

      qyid: 0,
      qyguid: '',
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
      this.qyguid = userInfo.qy.qyguid;
    } else {
      this.qyid = 0;
      this.qyguid = 0;
    }
    this.getBrand();
    this.getShopLabel();
    this.getDetail();
    this.id = this.$route.params.id;
  },
  methods: {
    getDetail() {
      let { id } = this.$route.params;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id }).then((res) => {
        let bannerList = [];
        bannerList.push(res.banner);
        bannerList.push(res.banner2);
        bannerList.push(res.banner3);
        bannerList.push(res.banner4);
        bannerList.push(res.banner5);
        let filter = bannerList.filter((v) => v != "");
        this.bannerList = filter;
        this.detail = res;
        Toast.clear();
      });
    },
    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        this.shopLabelFirst = res;
      });
    },
    // 品牌标签
    getBrand() {
      let { qyguid } = this;
      getBrandList({ qyguid }).then((res) => {
        this.brandList = res;
      });
    },
    // 商品所属分类
    label_name(id, id2, id3) {
      let { shopLabelFirst } = this;
      if (shopLabelFirst.length > 0 && id) {
        // 一级分类
        let filter = shopLabelFirst.filter((v) => v.id == id);
        if (filter.length > 0) {
          if (id2) {
            // 二级分类
            let filter2 = filter[0].childs2.filter((v) => v.id == id2);
            if (filter2.length > 0) {
              if (id3) {
                // 三级分类
                let filter3 = filter2[0].childs3.filter((v) => v.id == id3);
                return (
                  filter[0].labelname +
                  "、" +
                  filter2[0].labelname +
                  "、" +
                  filter3[0].labelname
                );
              }
              return filter[0].labelname + "、" + filter2[0].labelname;
            }
          }
          return filter[0].labelname;
        }
      }
    },
    // 根据品牌id获取品牌name
    brand_name(id) {
      let { brandList } = this;
      if (brandList.length > 0 && id) {
        let filter = brandList.filter((v) => v.id == id);
        if (filter.length > 0) {
          return filter[0].labelname;
        } else {
          return "";
        }
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>

<style lang="less" scoped>
.goodsManageAddPage {
  font-size: 26px;
  color: #404d6c;
  padding-bottom: 210px;
  .my-swipe {
    height: 750px;
    background: #f8f8f8;
  }
  .good_description {
    padding: 96px 70px 150px;
    .item {
      margin-bottom: 38px;
      p {
        margin-bottom: 15px;
      }
    }
  }
  .good_operation {
    font-size: 26px;
    color: #eb1b3d;
    flex-flow: row wrap;
    margin-bottom: 180px;
    a {
      color: #eb1b3d;
    }
    .item {
      flex-shrink: 0;
      width: 50%;
      text-align: center;
      height: 90px;
      line-height: 90px;
      border-bottom: 1px solid #adadad;
      box-sizing: border-box;
      &:nth-child(2n-1) {
        border-right: 1px solid #adadad;
      }
      &:nth-child(1),
      &:nth-child(2) {
        border-top: 1px solid #adadad;
      }
    }
  }
}
</style>